<template>
    <hr class="divider" :class="[{'with-text': text, 'is-vertical': vertical}]" :style="style" :data-content="text">
</template>

<script>
import {formatDimension} from "@spoferan/spoferan-ts-core";

    export default {
        name: "Divider",

        props: {
            // The text to display within the dividing line
            text: {
                type: String,
                default: null
            },

            // The vertical spacing (or horizontal for vertical dividers)
            margin: {
                type: [Number, String],
                default: 32
            },

            // Whether the divider shall be rendered vertically
            vertical: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            style() {
                if (this.vertical) {
                    return {
                        'margin-left': formatDimension(this.margin),
                        'margin-right': formatDimension(this.margin)
                    }
                }
                return {
                    'margin-top': formatDimension(this.margin),
                    'margin-bottom': formatDimension(this.margin)
                }
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
hr {
  border-color: #e6ecf5;
  border-style: solid;
}

hr.divider {
  display: block;
  flex: 1 1 0;
  max-width: 100%;
  height: 0;
  max-height: 0;
  transition: inherit;
  margin-left: 0;
  margin-right: 0;
  border: 0 solid #e6ecf5;
  border-top-width: thin;
  position: relative;
}
hr.divider.with-text:after {
  content: attr(data-content);
  position: absolute;
  color: #465050;
  text-transform: uppercase;
  padding: 0 15px;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  left: 50%;
}
hr.divider.is-vertical {
  align-self: stretch;
  display: inline-flex;
  height: inherit;
  min-height: 100%;
  max-height: 100%;
  max-width: 0;
  width: 0;
  vertical-align: text-bottom;
  border: 0 solid #e6ecf5;
  border-right-width: thin;
  margin-top: 0;
  margin-bottom: 0;
}
</style>